import { useEffect, useRef } from "react";
import styles from "./ConfirmModal.module.scss";
import WithModal, { CommonModalPropsI } from "@components/HOC/withModals";
import { MODALS_ENUM } from "@constants/Modals";
import Title from "@components/global/new/Title/Title";
import { ReactComponent as CloseIcon } from "@assets/icons/close.svg";
import { Button } from "antd";
export interface ConfirmModalExposedPropsI {
  title?: string;
  subtitle?: string;

  onConfirm(): void;
  onCancel?(): void;
  onReject?(): void;
}

interface ConfirmModalPropsI
  extends CommonModalPropsI,
  ConfirmModalExposedPropsI { }

function ConfirmModal({
  title,
  handleClose,
  onCancel,
  onConfirm,
  onReject,
  formatMessage,
  ...props
}: ConfirmModalPropsI) {
  const onConfirmHandler = () => {
    onConfirm();
    handleClose();
  };

  const onCancelHandler = () => {
    onCancel && onCancel();
    handleClose();
  };

  const onRejectHandler = () => {
    onReject && onReject();
    handleClose();
  }

  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (ref.current && ref.current.parentElement) {
      ref.current.parentElement.style.width = "380px";
    }
  }, [ref]);

  return (
    <div className={styles.wrapper} ref={ref}>
      <div className={styles.title_wrapper}>
        <Title className={styles.title}>
          {title || formatMessage({ id: "modal.confirm.title" })}
        </Title>
        {onReject && <CloseIcon className={styles.close} onClick={onRejectHandler} />}
      </div>
      {props.subtitle && (
        <Title className={styles.subtitle}>{props.subtitle}</Title>
      )}

      <div className={styles.btns}>
        <Button autoFocus className={styles.button} onClick={onConfirmHandler} type="primary">
          {formatMessage({ id: "modal.confirm.btn.yes" })}
        </Button>
        <Button className={styles.button} onClick={onCancelHandler}>
          {formatMessage({ id: "modal.confirm.btn.no" })}
        </Button>
        {onReject && (
          <Button className={styles.button} onClick={onRejectHandler}>
            {formatMessage({ id: "modal.confirm.btn.cancel" })}
          </Button>
        )}
      </div>
    </div>
  );
}

export default WithModal(MODALS_ENUM.CONFIRM_MODAL, ConfirmModal, {
  style: { padding: 0 },
  hideIcon: true,
});
